<script lang="ts">
  import { getAbsoluteUrl, getFooterComponentData } from '../../../common/util';

  export let metaData;
  let compSlotData: any[] = []; // This will hold the data for the footer links
  let loading = true; // A loading state to indicate data fetching
  const footerSlotData = metaData.find(x => x?.position === 'Footer');
  const mciCertificateData = metaData.find(x => x.position === 'FooterMciCertificate');
  console.log(metaData, 'metaDatabottom');

  // This function fetches footer component data asynchronously and handles errors
  async function getData(data: any) {
    if (!data) return;

    try {
      const res = await getFooterComponentData(data);
      compSlotData = res?.component || [];
    } catch (error) {
      console.error('Error fetching footer data:', error);
      compSlotData = []; // Set to an empty array on error
    } finally {
      loading = false; // End the loading state after fetching
    }
  }

  // Only call getData if navigationNode exists
  $: {
    if (footerSlotData?.components?.component) {
      footerSlotData?.components?.component.forEach(comp => {
        if (comp?.navigationNode && !compSlotData.length) {
          getData(comp?.navigationNode); // Fetch data only once per component
        }
      });
    }
  }
</script>

<div class="row column">
  <div class="section-bottom">
    {#each footerSlotData?.components.component as comp}
      <div
        class="col-sm-12 col-lg-4 content d-flex
          {comp?.uid === 'FooterPayLogoParagraphComponent' ? 'justify-content-center' : ''}
          {comp?.uid === 'FooterCopyrightParagraphComponent' ? 'copyright' : ''}
        "
      >
        {#if comp?.content}
          {@html comp?.content} <!-- Render HTML content directly -->
        {:else if comp?.navigationNode}
          <!-- Show loading state while fetching -->
          {#if loading}
            <p>Loading links...</p>
          {:else if compSlotData.length > 0}
            <ul class="nav aligns">
              {#each compSlotData as link}
                <li class="nav-item">
                  <a class="nav-link bottom-links" href={getAbsoluteUrl(link?.url)}>
                    {link?.linkName}
                  </a>
                </li>
              {/each}
            </ul>
          {:else}
            <p>No links available</p>
            <!-- Handle empty or failed data -->
          {/if}
        {/if}
      </div>
    {/each}
  </div>
  {#if mciCertificateData?.components?.component?.length}
    {#each mciCertificateData.components.component as comp}
      {#if comp.typeCode === 'CMSParagraphComponent'}
        {@html comp?.content}
      {/if}
    {/each}
  {/if}
  <!-- {#if $footerData?.footerCertificateSlotContents?.length}
    {#each $footerData?.footerCertificateSlotContents as link, i}
      {@html link}
    {/each}
  {/if} -->
</div>

<style lang="scss">
  @import '../../../common/styles/vars';
  @media screen and (min-width: 1024px) {
    .column {
      padding: 0 2.4rem;

      .section-bottom {
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        border-top: solid 0.1rem $color-alabaster-gray;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        margin-top: 3rem;
        padding-bottom: 2.5rem;
        padding-top: 1rem;
        @include desktop-max-width {
          margin-top: 0;
          background: $neutral-dark-01;
        }
      }
    }
  }
  .column {
    .section-bottom {
      border-top: solid 0.1rem $color-alabaster-gray;
      margin-top: 3rem;
      padding-top: 1rem;
      text-align: center;
      @include desktop-max-width {
        background: $neutral-dark-01;
        margin-top: 0;
      }
      .content {
        :global {
          p {
            color: $neutral-dark-05;
            font-size: 1.4rem;
            font-weight: 400;
            line-height: 16px;
            margin: 2.4rem 0;
            text-align: center;
          }
          img {
            max-width: 140px;
            margin-top: 2.4rem;
          }
        }
      }
      .copyright {
        @media screen and (max-width: 992px) {
          justify-content: center;
        }
      }
      .content {
        .nav {
          .nav-link {
            margin-left: 1.5rem;
            padding: 0;
          }
          .nav-item {
            a {
              color: #fefefe;
              display: block;
              font-size: 1.4rem;
              line-height: 1.43;
            }
          }
          .nav-link.active,
          .nav-link:hover {
            text-decoration: underline;
          }
        }
        p {
          color: $color-white;
          font-size: 1.4rem;
          font-weight: 300;
          line-height: 1.43;
          margin: 1.5rem 0;
          text-align: center;
        }
      }

      .aligns {
        @media (max-width: 992px) {
          display: flex;
          justify-content: space-between;
          width: 100%;
        }
        justify-content: flex-end;
        margin: 24px 0;
      }
    }
    :global {
      .c_legalinfo {
        background: $neutral-dark-01;
        align-items: center;
        display: flex;
        flex-direction: column-reverse;
        justify-content: center;
        width: max-content;
        @include desktop-max-width {
          display: flex;
          flex-direction: column;
          background: $color-white;
          padding: 0;
          width: 100%;
        }
        p {
          color: $neutral-dark-04;
          @include desktop-max-width {
            order: 1;
            border-top: 1px solid $neutral-dark-04;
            color: $neutral-dark-01;
            font-size: 11px;
            margin-top: 0;
            padding: 15px;
          }
        }
      }
    }
  }
</style>
